import { createMuiTheme } from '@material-ui/core/styles'

export const spacing = 6
export const fontSize = 10 // (between 1.5 and 2) * spacing

const headerHeight = spacing * 8
const sidebarWidth = spacing * 70
const acoordionMainHeight = spacing * 10.5
const containerAccordionMaxHeight = acoordionMainHeight * 3 + headerHeight

const theme = createMuiTheme({
  header: {
    container: {
      height: headerHeight,
      zIndex: 1201
    },
    dropDown: {
      backgroundColor: '#ffffff',
      paddingLeft: spacing,
      paddingRight: spacing,
      borderRadius: spacing
    },
    title: {
      marginLeft: spacing * 5
    }
  },
  containerAccordion: {
    maxHeight: `calc(100vh - ${containerAccordionMaxHeight}px - 60px)`,
    overflow: 'scroll'
  },
  containerPDIAccordion: {
    maxHeight: `calc(100vh - ${containerAccordionMaxHeight}px - 10px)`,
    overflow: 'scroll'
  },
  sidebar: {
    top: headerHeight,
    width: sidebarWidth,
    height: `calc(100vh - ${headerHeight + 1}px)`
  },
  overrides: {
    spacing,
    MuiCssBaseline: {
      '@global': {
        html: {
          fontSize,
          backgroundColor: '#f1f5f5'
        },
        '*::-webkit-scrollbar': {
          width: spacing,
          height: spacing
        },
        '*::-webkit-scrollbar-track': {
          // eslint-disable-next-line prettier/prettier
          '-webkit-box-shadow': `inset 0 0 ${
            spacing * 0.75
          }px rgba(222, 222, 222, .75)`
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0, 0, 0, .5)',
          borderRadius: spacing * 0.5
        }
      }
    },
    MuiTypography: {
      body1: {
        fontSize: '1.35rem'
      }
    },
    MuiTreeView: {
      root: {
        width: '100%'
      }
    },
    MuiTreeItem: {
      root: {
        width: '100%',
        border: '0px solid white',
        marginLeft: 0
      },
      group: {
        margingLeft: 0
      },
      label: {
        minHeight: spacing * 8,
        paddingLeft: spacing,
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
          backgroundColor: 'transparent'
        },
        backgroundColor: 'transparent !important'
      },
      iconContainer: {
        order: 2,
        paddingRight: spacing
      },
      content: {
        borderBottom: '1px solid #ffffff'
      }
    },
    MuiContainer: {
      root: {
        padding: spacing * 3
      }
    },
    MuiSvgIcon: {
      root: {
        colorPrimary: '#65848b'
      }
    },
    MuiAccordion: {
      root: {
        marginBottom: 0,
        border: '1px solid #f1f5f5',
        '&$expanded': {
          margin: 0
        },
        '&.secondChildren': {
          position: 'unset'
        }
      }
    },
    MuiAccordionSummary: {
      root: {
        minHeight: 0,
        '&$expanded': {
          minHeight: 0
        },
        '&.main': {
          height: acoordionMainHeight,
          color: 'white',
          background: 'rgb(132 162 169)'
        },
        '&.firstChildren': {
          background: '#becece',
          height: spacing * 6.5
        },
        '&.secondChildren': {
          // border: '1px solid blue',
          background: '#dee8e8',
          height: spacing * 8,
          paddingLeft: spacing * 5
        },
        '&.table': {
          paddingLeft: '0px'
        }
      }
    },
    MuiAccordionDetails: {
      root: {
        padding: 0,
        '&.lastChildren': {
          display: 'unset'
        },
        '&.table': {
          display: 'block'
        }
      }
    },
    MuiFormLabel: {
      root: {
        color: '#f1f5f5'
      }
    }
  },
  typography: {
    caption: {
      letterSpacing: 0,
      fontSize: '1rem'
    },
    subtitle1: {
      fontSize: '2rem',
      fontWeight: 'bold'
    },
    subtitle2: {
      fontSize: '1.24rem',
      fontWeight: 'bold'
    },
    h5: {
      fontSize: '1.40rem',
      fontWeight: 'bold'
    },
    h6: {
      fontSize: '1.3rem',
      fontWeight: 'bold'
    }
  },
  palette: {
    text: {
      primary: '#4d4d4d',
      secondary: '#be4e6c',
      info: '#f1f5f5'
    },
    action: {
      active: '#707070',
      hoverOpacity: 0.1
    },
    primary: {
      main: '#65848b!important'
    },
    secondary: {
      main: '#be4e6c'
    },
    info: {
      main: '#be4e6c'
    },
    error: {
      main: '#be4e6c'
    },
    background: {
      default: '#f1f5f5',
      paper: '#f1f5f5'
    }
  }
})
export default theme
